import React from 'react';
import CheckboxSubject from './CheckboxSubject';

class SubjectFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = { subjectCheckboxes: [] };
    }

    handleChange = (event) => {
        let subjectCheckboxes = this.state.subjectCheckboxes
        subjectCheckboxes.forEach(subject => {
            if (subject.id === event.target.id) {
                subject.isChecked = event.target.checked
            }
        });
        this.setState({ subjectCheckboxes: subjectCheckboxes });
        this.props.onChange(event);
    }

    render() {
        return (
            <div >
                <input type="checkbox" id="chkAllSubjects" name="chkAllSubjects" value="checkedall" defaultChecked onChange={this.props.checkAllSubjects} />
                <em><label className="checkbox-label" htmlFor="chkAllSubjects">Check / Uncheck All</label></em>
                <ul>
                    {
                        this.props.subjectCheckboxes.map((subject) => {
                            return this.props.careerFilter.includes(subject.career)? <CheckboxSubject name="chkSubject" key={subject.id} onChange={this.handleChange}  {...subject} />:null
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default SubjectFilter;
